//import { handleLogout } from 'redux/modules/authentication';
//import { refreshToken } from 'api/auth';
//import { saveLoginToken, setApiRequestToken } from 'utils/helpers';


const Eloquent = window.Eloquent;


/**
 * Refreshes user login token
 */
/*
async function refreshUserLoginToken() {
    const { data: { token } } = await refreshToken();

    saveLoginToken(token);
    setApiRequestToken();
}
*/


/**
 * Intercept all api calls to site backend and handle errors
 * @param {Function} dispatch - redux store dispatch function
 */
export function apiInterceptor(dispatch) {
    Eloquent.addResponseInterceptor((resp) => {
        if (!resp.isOk || resp.status >= 500) {

            /*
            // This causes infinte loop on entering wrong password. 
            if (resp.status === 401) {
                const endpoint = resp.request.responseURL.split('/').pop();

                if (endpoint !== 'refresh') {
                    refreshUserLoginToken();
                }
                else {
                    dispatch(handleLogout());
                }
            }
            */

            let error = new Error(resp.statusText);

            error.response = resp;
            throw error;
        }
    });
}



// WEBPACK FOOTER //
// ./src/api/interceptor.js